import { Dispatch } from 'redux'
import {
    ClientSearchInterface,
    ClientSearchActionTypes,
    ClientSearchEnum,
    ClientType,
    ClientSearchFilter
} from '../storeTypes'
import { sendMessageToWorkerWithResponse } from 'helpers/communication'
import { constants } from 'helpers'

export const clientSearchAction =
    ({ searchValue, villageIds }: ClientSearchInterface) =>
    async (dispatch: Dispatch<ClientSearchActionTypes>) => {
        const allClientList: ClientType[] = []
        dispatch({ type: ClientSearchEnum.FETCHING_CLIENT_SEARCH })

        const { storedData: clients } = await sendMessageToWorkerWithResponse({
            [constants.MESSAGES.GET_CLIENTS]: {
                clientType: constants.CLIENT_TYPES.ALL_CLIENT,
                villageIds,
                filter: ClientSearchFilter.VILLAGE
            }
        })
        allClientList.push(...clients)
        dispatch({
            type: ClientSearchEnum.FETCH_CLIENT_SEARCH,
            payload: {
                allClientList,
                searchParams: searchValue
            }
        })
    }

export const clientSearchByPhoneAction =
    ({ phone, villageIds }: { phone: string; villageIds: string[] }) =>
    async (dispatch: Dispatch<ClientSearchActionTypes>) => {
        const allClientList: ClientType[] = []
        dispatch({ type: ClientSearchEnum.FETCHING_CLIENT_SEARCH })

        const { storedData: clients } = await sendMessageToWorkerWithResponse({
            [constants.MESSAGES.GET_CLIENTS]: {
                clientType: constants.CLIENT_TYPES.ALL_CLIENT,
                villageIds,
                filter: ClientSearchFilter.VILLAGE
            }
        })
        allClientList.push(...clients)
        dispatch({
            type: ClientSearchEnum.SEARCH_CLIENT_BY_PHONE,
            payload: {
                allClientList,
                searchParams: { primaryPhone: phone }
            }
        })
    }

export const clearClientSearchAction =
    () => (dispatch: Dispatch<ClientSearchActionTypes>) => {
        dispatch({ type: ClientSearchEnum.CLEAR_CLIENT_SEARCH })
    }
